import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { ILabel } from '../../../../../utils/types/contentful';

export interface CompareAtPriceProps {
  currency: ILabel;
  compareAtPrice?: ILabel;
  onClick?: () => void;
}

export const CompareAtPrice: React.FC<CompareAtPriceProps> = ({
  productCategory,
  compareAtPrice,
  currency,
}) => (
  <div
    className={`line-through text-${compareAtPrice.size || ''}`}
    style={{
      textDecorationColor: 'black',
      textDecorationThickness: 1,
    }}>
    <Label
      type='span'
      weight='light'
      size='base'
      {...compareAtPrice}
    />
    <span>
      <Label
        type='span'
        weight='light'
        size='base'
        {...currency}
      />
    </span>
  </div>
);
